import { useCallback, useEffect, useState } from 'react';

import { Api } from '../../api/api';

import type { OverviewState } from './OverviewState';

/** Mirrors android/…/Screens/Overview/OverviewViewModel.kt. */
export function useOverview() {
  const [state, setState] = useState<OverviewState>({
    isLoading: true,
    overview: null,
    error: null,
    errorCorrelationId: null,
  });

  const load = useCallback(async (): Promise<void> => {
    setState((current) => ({ ...current, isLoading: true, error: null, errorCorrelationId: null }));

    const result = await Api.readFamilyOverview();

    setState(
      result.ok
        ? { isLoading: false, overview: result.value, error: null, errorCorrelationId: null }
        : {
            isLoading: false,
            overview: null,
            error: result.error.message,
            errorCorrelationId: result.error.correlationId ?? null,
          },
    );
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { state, load };
}
